import { useSelector } from 'react-redux'
import SportsMatchesList from '../../../components/SportsMatchesList';

function SoccerMatchesList() {
    const soccerMatches = useSelector(state => state.matches.soccer.matches.data);

    return (
        <SportsMatchesList sportId={1} matchesList={soccerMatches} />
    )
}

export default SoccerMatchesList